/**
 * Where a Warehouse or Invoicing document comes from. R2 is the system of record until cutover:
 * R2 rows carry an R2 tag, and actions R2 owns are hidden with a one-line reason (or, for R2
 * purchase orders and master bills, allowed with a reset notice — Alex, 2026-10-07).
 */

export type RecordSource = 'r2' | 'portal';

export function recordSourceLabel(source: RecordSource | null | undefined): string {
  return source === 'r2' ? 'R2' : 'Portal';
}

/** The canonical R2 test for transfers (same columns as the database's transfer_is_r2_managed). */
export function isR2ManagedTransfer(row: {
  r2_transfer_order_iid?: number | string | null;
  r2_transfer_order_id?: string | null;
  r2_contract_iid?: number | string | null;
} | null | undefined): boolean {
  if (!row) return false;
  return Boolean(
    (row.r2_transfer_order_iid != null && String(row.r2_transfer_order_iid) !== '')
    || (row.r2_transfer_order_id != null && String(row.r2_transfer_order_id) !== '')
    || (row.r2_contract_iid != null && String(row.r2_contract_iid) !== ''),
  );
}

export const R2_TRANSFER_REASON =
  'Managed in R2. R2 records this transfer’s picking, shipping and receiving until cutover, so those actions are hidden here. Shipments, linked events and chat still work in the Portal.';

export const R2_INVOICE_REASON =
  'Imported from R2. Changes, voids and payments happen in R2.';

export const R2_SUBRENTAL_REASON =
  'Managed in R2. R2 records this cross-rental’s receiving and returns until cutover, so those actions are hidden here.';

/** One line in action dialogs on R2 purchase orders and master bills. */
export const R2_RESET_NOTICE =
  'R2 still owns this record. Its nightly sync may undo this change.';
